export function capitalizeWords(string: string) {
  return string.replace(/\b./g, (letter) => letter.toUpperCase());
}

export function escapeRegex(str: string): string {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

/** Whether `char` can appear within a JavaScript identifier. */
export function isIdentifierChar(char: string | undefined): boolean {
  return (
    char !== undefined &&
    ((char >= "a" && char <= "z") ||
      (char >= "A" && char <= "Z") ||
      (char >= "0" && char <= "9") ||
      char === "_" ||
      char === "$")
  );
}
